<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
    "2xl": 'w-10 h-10'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  stroke={color}
  stroke-width={strokeWidth}
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 48 48"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <line class="a" x1="31.3799" y1="24.233" x2="31.3799" y2="31.1083" /><line
    class="a"
    x1="34.2426"
    y1="24.233"
    x2="34.2426"
    y2="31.1083"
  /><path
    class="a"
    d="M41.2092,17.4747c-.0144,1.7955.029,3.5938-.0222,5.3874-.161.9077-1.1506.9093-1.8716.8718h-27.85c-1,.0173-1.1756-1.0527-1.0924-1.827.0142-1.5506-.0289-3.104.0221-4.6527.1611-.9077,1.1506-.9093,1.8716-.8718h27.85a1.0949,1.0949,0,0,1,1.0925,1.0925Z"
  /><path
    class="a"
    d="M39.5211,24.8492c-.0144,1.7955.029,3.5937-.0221,5.3874-.1611.9076-1.1506.9093-1.8717.8718H9.7774c-1,.0173-1.1755-1.0528-1.0924-1.827.0143-1.5506-.0289-3.104.0221-4.6528.1611-.9076,1.1506-.9093,1.8716-.8717h27.85a1.0949,1.0949,0,0,1,1.0925,1.0924Z"
  /><path
    class="a"
    d="M36.07,32.31c-.0186,1.4551.02,2.9131-.0356,4.3662-.1581.8871-1.1217.91-1.8322.8661L7.893,37.4607c-.9786.0163-1.1748-1.0265-1.0869-1.7917.0176-1.2231-.0207-2.4492.0334-3.67.1581-.8871,1.1218-.91,1.8322-.8661l26.3091.0813A1.095,1.095,0,0,1,36.07,32.31Z"
  /><path
    class="a"
    d="M37.0577,38.6587c-.0141,1.319.0287,2.6408-.0221,3.9579-.146.8532-1.0657.92-1.7587.8718H11.8077c-.9422.0222-1.1812-.973-1.0924-1.7234.0139-1.1086-.0284-2.22.0221-3.3269.146-.8532,1.0657-.92,1.7586-.8717H35.9653a1.0948,1.0948,0,0,1,1.0924,1.0925Z"
  /><line class="a" x1="21.5385" y1="23.7572" x2="21.5385" y2="31.1083" /><line
    class="a"
    x1="15.3349"
    y1="23.7572"
    x2="15.3349"
    y2="31.1083"
  /><line class="a" x1="16.22" y1="16.3827" x2="16.22" y2="23.7338" /><line
    class="a"
    x1="19.6656"
    y1="16.3827"
    x2="19.6656"
    y2="23.7338"
  /><line class="a" x1="18.3721" y1="40.5274" x2="29.3995" y2="40.5274" /><path
    class="a"
    d="M35.0292,11.5416c-.0143,1.3189.0283,2.6408-.0226,3.9579-.1462.8532-1.0659.92-1.7588.8715L9.7786,16.3677c-.9423.0221-1.1811-.9732-1.0923-1.7237.0141-1.1086-.028-2.22.0226-3.3268.1462-.8533,1.0659-.92,1.7588-.8715l23.4693.0033a1.0949,1.0949,0,0,1,1.0923,1.0926Z"
  /><path
    class="a"
    d="M37.3509,5.59c-.0131,1.3188.03,2.6412-.02,3.9579-.1346.8066-.9973.933-1.6663.8728-7.3481.0011-14.6967.0172-22.0437.0089-.835-.0568-1.0627-.9373-.9816-1.6285.013-1.1381-.0295-2.28.02-3.4156.1345-.8066.9973-.933,1.6663-.8728,7.3481-.0011,14.6967-.0172,22.0437-.0089A1.0949,1.0949,0,0,1,37.3509,5.59Z"
  /><line class="a" x1="16.3436" y1="13.4075" x2="27.371" y2="13.4089" />
</svg>
